export interface IStorageConnectionCredentials {
  databaseUuid: string;

  token: string;
}